import React from 'react';
import './Emergency.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import EmergencyImg from '../../assets/emergency.png';

const Emergency = () => {
    return (
        <section className='emergency-section'>
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="emergency-img">
                            <img src={EmergencyImg} alt="Emergency" />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="emergency-text">
                            <SectionTitle subTitle="📍 Location & Timings" title="Visit TRUECARE Dental Center" description="📍 Shop No. 6, Sharma Garden, Near Mahindra Petrol Pump, Yamunanagar – 135001 (HR)"/>

                            <div className="timing-info">
                                <h4>🕙 Walk-in Timings:</h4>
                                <p><strong>Morning:</strong> 10:00 a.m. – 1:30 p.m.</p>
                                <p><strong>Evening:</strong> 5:30 p.m. – 7:30 p.m.</p>
                            </div>

                            <div className="theme-btn">
                                <a href="tel:6395947006" className="call-button">
                                    <span className="call-icon">📞</span>
                                    Call: 6395947006
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Emergency;